<script setup lang="ts">
import { computed } from "vue";
import { storeToRefs } from "pinia";

import { useEditTransaction } from "@/components/EditTransaction/state.ts";

const state = useEditTransaction();

const { amount } = storeToRefs(state);

const localAmount = computed({
  get: () => amount.value / 100,
  set: (value: number) => {
    // Cents are integers: `19.99 * 100` is 1998.9999999999998, which would be stored and sent.
    // An emptied field arrives as "", which must clear the amount rather than keep the old one.
    amount.value = value ? Math.round(value * 100) : 0;
  },
});
</script>

<template>
  <div class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
    <label class="block text-sm/6 font-medium text-gray-900" for="amount">Bedrag</label>
    <div class="sm:col-span-2">
      <div
        class="flex items-center rounded-md bg-white pl-3 outline -outline-offset-1 outline-gray-300 focus-within:outline focus-within:-outline-offset-2 focus-within:outline-indigo-600 sm:max-w-md"
      >
        <div class="shrink-0 select-none text-base text-gray-500 sm:text-sm/6"></div>
        <input
          id="amount"
          v-model="localAmount"
          class="block min-w-0 grow py-1.5 pl-1 pr-3 text-base text-gray-900 placeholder:text-gray-400 outline-0 sm:text-sm/6"
          min="0.00"
          name="amount"
          placeholder="12.99"
          step="0.01"
          type="number"
        />
      </div>
    </div>
  </div>
</template>
